import LogoGtms from "../../../components/images/logo_gtms/LogoGtms";
import usePageView from "../../../hooks/analytics/usePageView.js";
import { config } from "../../../config/Constants.js";
import useIpAddress from "../../../hooks/auth/ip.js";
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import React, { useState } from "react";
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import Swal from 'sweetalert2';
import Axios from 'axios';
import './login.css';

const Login = () => {
  usePageView();
  //useIpAddress('LOGIN');
  const navigate = useNavigate();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const getAuthToken = () => { return Cookies.get('gtms-cp-auth'); }

  const register = () => { 
    ReactGA.event({ category: 'Button', action: 'Click', label: 'Register Button', value: 1 });
    navigate('/register'); 
  }

  const forgotPassword = () => { 
    ReactGA.event({ category: 'Button', action: 'Click', label: 'Forgot Password Button', value: 1 });
    navigate('/forgotpassword');
  }

  const login = async() => {
    ReactGA.event({ category: 'Button', action: 'Click', label: 'Login Button', value: 1 });
    const response = await Axios.post(config.url.LOGIN_URL, {
      username: username,
      password: password,
    });

    const accessToken = response.data.accessToken;
    setAuthToken(accessToken);
    const isVerified = await verifyToken();
    navigateLanding(isVerified)
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    await login();
  };

  const navigateLanding = async(isVerified) => {
    if (isVerified === true) {
      const existingUser = await getUserCreds();
      const role = Cookies.get('cp-role');
      if (existingUser) {
        const page = await getLandingPage(role);
        navigate(page);
      } else {
        navigate('/unauthorized');
      }
    } else {
      Swal.fire({ icon: 'error', title: 'Incorrect username or password', });
      navigate('/');
    }
  }

  const verifyToken = async() => {
    const token = getAuthToken();
    const response = await Axios.post(config.url.VERIFY_TOKEN, { token: token, });
    return response.data.isVerified;
  }

  const getLandingPage = async(role) => {
    const response = await Axios.get(config.url.GET_LANDING_PAGE, { params: { role: role, }});
    return response.data.page;
  }

  const getUserCreds = async() => {
    let existingUser = false;
    const response = await Axios.post(config.url.GET_USER_CREDS, { username: username, });
    const userCreds = response.data.creds;
    if (userCreds) {
      existingUser = true;
      await setUserCreds(userCreds);
    }
    return existingUser
  }

  const setUserCreds = async (creds) => {
    Cookies.set('cp-un', creds.USERNAME, { expires: 1 });
    Cookies.set('cp-cn', creds.CUSTOMER_NAME, { expires: 1 });
    Cookies.set('cp-ci', creds.CUSTOMER_ID, { expires: 1 });
    Cookies.set('cp-csn', creds.CLIENT_SHORT_NAME, { expires: 1 });
    Cookies.set('cp-a', creds.IS_ACTIVE, { expires: 1 });
    Cookies.set('cp-admin', creds.IS_ADMIN, { expires: 1 });
    Cookies.set('cp-role', creds.ROLE_ID, { expires: 1 });
    Cookies.set('cp-vr', creds.VENDOR_NAME, { expires: 1 });
    localStorage.setItem("name", creds.NAME);
  }

  const setAuthToken = (token) => {
    Cookies.set('gtms-cp-auth', token, { secure: true, expires: 1 });
  }

  return (
  <div className="loginPage">
    <div className="loginShell">
      <div className="loginHero">
        <div className="loginHeroPattern" aria-hidden="true"></div>
        <div className="loginHeroRings" aria-hidden="true"></div>
        <div className="loginHeroBrand">
          <LogoGtms/>
        </div>
        <h1 className="loginHeroTitle">
          Ship smarter.
          <span>Move faster.</span>
        </h1>
        <p className="loginHeroText">
          Monitor shipments, control transportation spend, and uncover savings from one centralized hub.
        </p>
        <div className="loginHeroTagline">
          <strong>Forensic Freight Optimization&#8482;</strong>
          <span>The systems driven approach to profitable logistics</span>
        </div>
        <div className="loginHeroStats">
          <div className="loginStat">
            <strong>Visibility</strong>
            <span>Shipment-Level Detail</span>
          </div>
          <div className="loginStat">
            <strong>Savings</strong>
            <span>Audit-Backed Insights</span>
          </div>
          <div className="loginStat">
            <strong>Coverage</strong>
            <span>All Modes, One Platform</span>
          </div>
        </div>
      </div>
      <div className="loginContainer">
        <div className="loginCardAccent" aria-hidden="true"></div>
        <div className="loginTop">
          <p className="loginCardEyebrow">Customer Portal</p>
          <div className="loginTitle">
            <h2>Welcome back</h2>
            <p>Sign in with your credentials to access your account.</p>
          </div>
        </div>
        <form className="loginForm" onSubmit={handleSubmit}>
          <div className="loginMid">
            <div className="loginField">
              <TextField 
                fullWidth
                size="small"
                id="username"
                label="Username"
                variant="outlined"
                onChange={e => setUsername(e.target.value)}
              />
            </div>
            <div className="loginField">
              <TextField 
                fullWidth
                size="small"
                id="password"
                type={showPassword ? 'text' : 'password'}
                label="Password"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <button
                      type="button"
                      className="loginFieldToggle"
                      onClick={() => setShowPassword((current) => !current)}>
                      {showPassword ? 'Hide' : 'Show'}
                    </button>
                  ),
                }}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="loginBottom">
            <Button
              type="submit"
              variant="contained"
              className="loginPrimaryButton"
              aria-label="Login">
              <span className="loginPrimaryButtonLabel">LOG IN</span>
            </Button>
          </div>
        </form>
        <div className="loginBottom loginBottomSecondary">
          <div className="loginSupportRow">
            <a className="forgotPasswordLink"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                forgotPassword();
              }}>
              Forgot Password
            </a>
          </div>
          <div className="loginAuthOptions">
            <p>New to GTMS? <a 
              className="signUpLink" 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                register();
              }}>
                Sign Up
              </a>
            </p>
          </div>
          <div className="loginTrustRow"></div>
        </div>
      </div>
    </div>
  </div> 
  )
}

export default Login
